import React, { useEffect, useRef, useState } from "react";
import {
    TextField,
} from "@mui/material";

function DataGridTextField({ onBlur = () => {}, ...props }) {

    const [commitValue, setCommitValue] = useState(props.value);
    const [editValue, setEditValue] = useState(props.value);

    const discardRef = useRef(false);

    useEffect(() => {
        setCommitValue(props.value);
        setEditValue(props.value);
    }, [props.value]);

    return (
        <TextField
            variant="standard"
            sx={{
                input: {
                    color: 'white',
                    fontSize: '13px',
                    padding: '4px 8px'
                },
                '& .MuiInput-underline:before': {
                    borderBottom: props.disabled ? 'none' : '1px solid rgba(84, 162, 119, 0.4)'
                },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                    borderBottom: props.disabled ? 'none' : '1px solid rgba(76, 146, 107, 0.8)'
                },
                '& .MuiInput-underline:after': {
                    borderBottom: props.disabled ? 'none' : '1px solid rgba(84, 162, 119, 1)'
                },
            }}
            fullWidth
            {...props}
            value={editValue}
            onChange={(event) => {
                setEditValue(event.target.value)
            }}
            onBlur={(e) => {
                if(discardRef.current === true) {
                    onBlur(e, commitValue)
                    setCommitValue(commitValue)
                    setEditValue(commitValue)
                    discardRef.current = false
                }
                else {
                    onBlur(e, editValue)
                }
            }}
            onKeyDown={(e) => {
                if (['Enter', 'NumpadEnter', 'Tab'].includes(e.key)) {
                    e.target.blur();
                }
                if (e.key === 'Escape') {
                    discardRef.current = true // Discard the current edit
                    e.target.blur()
                }
            }}
        />
    )
}

export default DataGridTextField;